import {Component, Inject, OnInit} from '@angular/core';
import { Location } from '@angular/common';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {faLock, faShip, faUser} from '@fortawesome/free-solid-svg-icons';
import {ActivatedRoute, Router} from '@angular/router';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { State } from '../../auth/login/reducers/login.reducer';
import { IUser } from '../../cognito.service';
import { CarsService } from '../cars.service';

interface UserInfo {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  notes: string;
}
@Component({
  selector: 'app-user-info-modal',
  templateUrl: './user-info-modal.component.html',
  styleUrls: ['./user-info-modal.component.scss']
})
export class UserInfoModalComponent implements OnInit {

  form: FormGroup;
  user: UserInfo;
  importType = 'new'

  constructor(private _fb: FormBuilder,
              private dialogRef: MatDialogRef<UserInfoModalComponent>,
              private carService: CarsService,
              @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const user = localStorage.getItem('userInfo');
    if( user) {
      try {
        this.user = JSON.parse(user)
      } catch (error) {
        console.log(error);
      }
    }
    if( !this.user) {
      this.user = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        notes: '',
      }
    }
    this.user.notes = ''
  }

  ngOnInit(): void {
    this.form = this._fb.group({
      email: [ this.user.email || '', [Validators.email]],
      notes: this.user.notes || '',
      phone: [this.user.phone || '', [Validators.required, Validators.pattern('[- +()0-9]+')]],
      firstName: [this.user.firstName || '', [Validators.required]],
      lastName: [this.user.lastName || '', [Validators.required]],
    });
  }

  submit() {
    localStorage.setItem('userInfo', JSON.stringify(this.form.value) )

    this.carService.updateNewInterest(this.data.id, this.form.value, this.importType).subscribe((res: any) => {
      this.dialogRef.close(this.form.value)
    });
  }

  close() {
    this.dialogRef.close()
  }

}
